<template>
  <div>
    <div class="row mb-1">
      <div class="col-md-12">
        <h4 class="text-uppercase mt-1">{{ lexicon.drop_add_money }}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card-deck-wrapper mb-3">
          <div class="card-deck">
            <div class="card">
              <div class="card-content">
                <div class="card-body">
                  <h4 class="card-title">{{ lexicon.drop_send_money }}</h4>
                  <p class=" card-text alert alert-primary">
                    {{ lexicon.drop_send_money_info }}
                  </p>

                  <table class="table small-table">
                    <tr>
                      <td>Найменування</td>
                      <td>ФОП Головатий Петро Олексійович</td>
                    </tr>
                    <tr>
                      <td>Рахунок (IBAN)</td>
                      <td>UA363052990000026001041800120</td>
                    </tr>
                    <tr>
                      <td>Код ЄДРПОУ(ОКПО)</td>
                      <td>3344309299</td>
                    </tr>
                    <tr>
                      <td>Найменування банку</td>
                      <td>АТ КБ «ПриватБанк»</td>
                    </tr>
                    <tr class="text-danger">
                      <td>Призначення платежу</td>
                      <td>Платіж згідно рахунку {{curdate}}{{user.id}}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-content">
                <div class="card-body">
                  <h4 class="card-title">
                    {{ lexicon.drop_pay_with_card }}
                  </h4>
                  <div id="liqpay_checkout" v-show="pay>0" ref="liqpay"></div>
                  <div v-if="pay == 0 || pay == 2">
                    <p class="card-text" v-show="pay==0">
                      {{ lexicon.drop_add_money_info }}
                    </p>
                    <label>{{lexicon.drop_enter_sum}}</label>
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="summ"
                          :class="{error : error}">
                      <div class="input-group-append">
                        <span class="input-group-text"> {{ lexicon[user.currency]}}</span>
                      </div>
                    </div>

                    <p class="card-text mt-50 mb-2">
                      <small class="">
<!--                        {{lexicon.drop_add_money_currency}}-->
<!--                        <br>-->
                        {{lexicon.drop_add_m_fee}}
                      </small>
                    </p>
                    <button class="btn btn-success btn-block" :disabled="error" @click="payForm">
                      {{lexicon.drop_go_to_pay}}
                    </button>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters, mapState} from 'vuex'
import axios from "axios";

export default {
  name: 'payment',
  data() {
    return {
      summ: 0,
      error: false,
      pay: 0,
      usd: '0 $'
    }
  },
  mounted() {
    // let liqpay = document.createElement('script')
    // liqpay.setAttribute('src', '//static.liqpay.ua/libjs/checkout.js')
    // document.head.appendChild(liqpay)
    let liqpay = document.createElement('script')
    liqpay.setAttribute('src', 'https://secure.wayforpay.com/server/pay-widget.js')
    document.head.appendChild(liqpay)

  },
  watch: {
    summ: function (val) {
      this.error = false
      // let usd = val / this.user.usd
      // this.usd = usd.toFixed(2) + " "+this.lexicon.drop_dollar_sign
      // this.error = (usd.toFixed(0) >= 3) ? false : true
      if (!this.error) {
        this.error = (val >= 14990) ? true : false
      }
      // this.error = (usd.toFixed(0) > -1) ? false : true
    }
  },

  created() {
    this.summ = (this.user.usd * 50).toFixed(0)
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
    ...mapState({
      lexicon: 'lexicon',
    }),
    curdate() {
      let date = new Date();

      return (date.getFullYear()-2000)+''+("0" + (date.getMonth() + 1)).slice(-2)+''+("0" + date.getDate()).slice(-2);
    }
  },
  methods: {
    payForm() {
      if (this.pay == 2) {
        this.$refs.liqpay.innerHTML = ''
        this.pay = 1;
      }
      axios.post('payment/', {'amount': this.summ}).then((result) => {
        this.pay = 1;
        eval(result.data.data.script)
        // let that = this;
        // window.LiqPayCheckout.init(result.data.data).on("liqpay.callback", function (data) {
        //     if (data.status == "failure") {
        //         that.pay = 2
        //     }
        // })
        // 	.on("liqpay.ready", function (data) {
        // }).on("liqpay.close", function (data) {
        // });
      })
    }
  }
}
</script>
